import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadPermissionsSuccess, loadSuccess } from "./userActions";
import * as request from "utility/request";
import { UserPermission } from "types/UserPermission";
import { VisibleSections } from "types/VisibleSections";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadUserPermissions = () => {
  return async (dispatch: RootDispatch) => {
    dispatch(load("userPermissions"));

    try {
      const res = await request.getResponseJson<UserPermission[]>(
        `${apiUrl}/api/user/reportControls`
      );
      dispatch(loadPermissionsSuccess("userPermissions", res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail("userPermissions", error));
    }
  };
};

export const loadVisibleSections = (reportControlId: string) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load("visibleSections"));

    try {
      const res = await request.getResponseJson<VisibleSections>(
        `${apiUrl}/api/user/visibleParts?reportControlId=${reportControlId}`
      );
      dispatch(loadSuccess("visibleSections", res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail("visibleSections", error));
    }
  };
};
